import React, { useEffect, useState } from "react";
/** @jsxImportSource @emotion/react */
import "twin.macro";
import Auth from "../../lib/middleware/auth";
import moment from "moment";
import dayjs from "dayjs";
import { updateBvn } from "../../redux/actions/wallet";
import { viewUserProfile } from "../../redux/actions/authentication";
import errorHandler from "../../redux/actions/errorHandler";
import hint from "../../assets/svg/hint.svg";
import userimg from "../../assets/svg/user.svg";
import pwd_hidden from "../../assets/svg/pwd_hidden_eye.svg";
import { isEmpty, Toast } from "../../lib/helpers/helpers";
import { useMutation } from "react-query";
import calender from "../../assets/svg/calender.svg";
import { Loading } from "..";
import { ArrowLeftOutlined, EyeTwoTone } from "@ant-design/icons";
import {
	btnStyle,
	inputStyle,
	LandingTitle,
} from "../../lib/styles/styleLibrary";
import { DatePicker, Image, Input, Modal } from "antd";
import lock from "../../assets/svg/lock_red.svg";
import { Wrapper } from "./component";

const BvnSetup = ({
	setIsBvn = () => {
		return null;
	},
	isBvn,
}) => {
	const user = Auth.getUser();
	const [bvn, setBvn] = useState({
		bvn: "",
		firstname: user?.firstname,
		lastname: user?.lastname,
		dateOfBirth: "",
		mobileNo: user?.phone,
	});
	const [wd, setWd] = useState(moment());

	useEffect(() => {
		if (!user) {
			return;
		}
		setBvn({
			...bvn,
			firstname: user?.firstname,
			lastname: user?.lastname,
			mobileNo: user?.phone,
		});

		// eslint-disable-next-line
	}, [user.firstname]);
	useEffect(() => {
		setBvn({ ...bvn, dateOfBirth: dayjs(wd).format() });
		// eslint-disable-next-line
	}, [wd]);

	// console.log(bvn);

	const { mutateAsync: handleBvn, isLoading: setBvnLoading } =
		useMutation(updateBvn);

	const handleUpdateBvn = async () => {
		if (
			isEmpty(bvn.bvn) ||
			isEmpty(bvn.firstname) ||
			isEmpty(bvn.lastname) ||
			isEmpty(bvn.mobileNo)
		) {
			Toast.fire({
				icon: "error",
				title: `Kindly fill all input fields correctly`,
			});
			return;
		}

		if (bvn.bvn.length !== 11) {
			Toast.fire({
				icon: "error",
				title: `Incomplete/Invalid BVN...`,
			});
			return;
		}
		if (
			moment(bvn.dateOfBirth).format("dd/mm/yy") ===
			moment().format("dd/mm/yy")
		) {
			Toast.fire({
				icon: "error",
				title: `Incorrect date of birth`,
			});
			return;
		}

		try {
			const res = await handleBvn(bvn);
			console.log(res);
			const { hasError, errors } = res.data;
			if (hasError) {
				return errorHandler(errors);
			}
			Toast.fire({
				icon: "success",
				title: `${res.data.message}\n ${res.data.data}`,
			});
			viewUserProfile();
			setIsBvn(false);
		} catch (err) {
			console.log("the set bvn error", err);
		}
	};

	return (
		<Wrapper>
			<Modal
				footer=""
				visible={isBvn}
				centered
				onCancel={() => setIsBvn(false)}
				maskClosable={false}>
				<div
					tw="mb-4 h-8 w-8 px-2 py-2 bg-gray-100 rounded-full hover:(cursor-pointer border-2 border-solid border-purple-800) flex flex-col items-center justify-center"
					onClick={() => setIsBvn(false)}>
					<ArrowLeftOutlined tw="hover:(text-purple-800 transform scale-125)" />
				</div>
				<LandingTitle tw="text-center text-lg! mb-4">
					Add your BVN
				</LandingTitle>
				<div tw="mt-4 mb-4!">
					<label
						htmlFor="name"
						className="label"
						tw="font-semibold text-base">
						Bank Verification Number (BVN)
					</label>
					<div tw="mt-4">
						<Input
							placeholder="0000000000"
							type="number"
							css={inputStyle}
							value={bvn.bvn}
							onChange={(e) =>
								setBvn({ ...bvn, bvn: e.target.value.trim() })
							}
							prefix={<img src={lock} alt="" tw="pr-2" />}
							iconRender={(visible) =>
								visible ? (
									<EyeTwoTone twoToneColor="#9797BD" />
								) : (
									<Image
										preview={false}
										src={pwd_hidden}
										alt=""
										width={20}
										height={20}
									/>
								)
							}
						/>
					</div>
					<div tw="mt-4">
						<div tw="pt-3 flex flex-row flex-wrap sm:flex-nowrap items-center justify-between gap-4">
							<div>
								<label htmlFor="name" className="label">
									First Name
								</label>
								<Input
									placeholder="First Name"
									type="text"
									css={inputStyle}
									value={bvn.firstname}
									onChange={(e) =>
										setBvn({
											...bvn,
											firstname: e.target.value,
										})
									}
									tw="w-full mt-2"
									prefix={
										<img src={userimg} alt="" tw="pr-2" />
									}
								/>
							</div>
							<div>
								<label htmlFor="name" className="label">
									Last Name
								</label>
								<Input
									placeholder="Last Name"
									type="text"
									value={bvn.lastname}
									onChange={(e) =>
										setBvn({
											...bvn,
											lastname: e.target.value,
										})
									}
									css={inputStyle}
									tw="w-full mt-2"
									prefix={
										<img src={userimg} alt="" tw="pr-2" />
									}
								/>
							</div>
						</div>
					</div>
					<div>
						<div tw="pt-3 flex flex-row flex-wrap sm:flex-nowrap items-center justify-between gap-4">
							<div tw="w-full">
								<label htmlFor="name" className="label">
									Phone number
								</label>
								<Input
									placeholder="Phone Number"
									type="text"
									css={inputStyle}
									value={bvn.mobileNo}
									onChange={(e) =>
										setBvn({
											...bvn,
											mobileNo: e.target.value,
										})
									}
									tw="w-full mt-2"
									prefix={
										<img src={userimg} alt="" tw="pr-2" />
									}
								/>
							</div>
							<div tw="w-full">
								<label htmlFor="name" className="label">
									Date of Birth
								</label>
								<div tw="relative w-full  mt-2">
									<div tw="absolute top-0 left-0 z-10">
										<img
											src={calender}
											alt=""
											tw="pr-2 absolute inset-3"
										/>
									</div>
									<DatePicker
										css={inputStyle}
										tw="w-full"
										suffixIcon={""}
										value={wd}
										disabledDate={(current) => {
											return (
												current && current > moment()
											);
										}}
										onChange={(date) => setWd(date)}
									/>
								</div>
							</div>
						</div>
					</div>
					<div tw="mt-4 mb-12">
						<p tw="flex items-center gap-4">
							<Image
								preview={false}
								src={hint}
								alt=""
								width={30}
								height={30}
							/>
							<span tw="text-appTextFaded">
								Why we ask for your BVN
							</span>
						</p>
						<span tw="text-appTextFaded">
							Your BVN only gives access to match your basic
							information with an existing database approved by
							CBN and in no way allows access to your bank account
							or banking history.
						</span>
					</div>

					<div tw="flex justify-center items-center w-full mt-4">
						<button css={btnStyle} onClick={handleUpdateBvn}>
							{setBvnLoading ? <Loading /> : "Confirm BVN"}
						</button>
					</div>
				</div>
			</Modal>
		</Wrapper>
	);
};

export default BvnSetup;
